export const HEADER_HEIGHT = 64

/** Baseline viewport width used for calculating resizable panel percentages */
export const BASELINE_VIEWPORT = 1440
